/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MissingJpkIdsDto
 */
export interface MissingJpkIdsDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof MissingJpkIdsDto
     */
    missingIds: Array<number>;
}

/**
 * Check if a given object implements the MissingJpkIdsDto interface.
 */
export function instanceOfMissingJpkIdsDto(value: object): value is MissingJpkIdsDto {
    if (!('missingIds' in value) || value['missingIds'] === undefined) return false;
    return true;
}

export function MissingJpkIdsDtoFromJSON(json: any): MissingJpkIdsDto {
    return MissingJpkIdsDtoFromJSONTyped(json, false);
}

export function MissingJpkIdsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MissingJpkIdsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'missingIds': json['missingIds'],
    };
}

export function MissingJpkIdsDtoToJSON(value?: MissingJpkIdsDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'missingIds': value['missingIds'],
    };
}

